import { Box, Typography, styled, useTheme } from '@mui/material';
import { getColorFromString } from '@ui-framework/index';

export const Circle = styled(Box, {
  shouldForwardProp: props => !['bgColor', 'size'].includes(props),
})(({ theme, bgColor, size }) => ({
  backgroundColor: bgColor,
  padding: theme.spacing(1),
  width: `${size}px`,
  height: `${size}px`,
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

function IconChip({ bgColor, iconColor, Icon, size }) {
  const theme = useTheme();

  const bgColorValue = getColorFromString(theme.palette, bgColor);
  const iconColorValue = getColorFromString(theme.palette, iconColor);

  return (
    <Circle size={size} bgColor={bgColorValue || bgColor}>
      <Icon
        sx={{ color: iconColorValue || iconColor, fontSize: `${size / 2.2}px` }}
      />
    </Circle>
  );
}

export const Container = styled(Box)(() => ({
  display: 'inline-flex',
  alignItems: 'center',
}));

function IconHeader({
  Icon = null,
  bgColor,
  iconColor,
  size,
  children,
  subSection = false,
}) {
  return (
    <Container>
      {Icon && !subSection && (
        <IconChip
          bgColor={bgColor || 'primary.light'}
          iconColor={iconColor || 'primary.light'}
          Icon={Icon}
          size={size || 40}
        />
      )}
      {Icon && subSection && (
        <Icon sx={{ backgroundColor: 'transparent', color: 'primary.main' }} />
      )}

      <Typography
        variant="h6"
        component="div"
        color="primary.main"
        sx={{
          fontWeight: 500,
          ...(Icon && { marginLeft: '10px' }),
          ...(subSection && { fontSize: '18px' }),
        }}>
        {children}
      </Typography>
    </Container>
  );
}

export default IconHeader;
